import React from 'react';
import Alert from 'components/ui/Alert';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';


const ShowRequiredDocsBanner = ({docsList = []}) => {
  const {t} = useTranslation();
  const isMultiRow = docsList.length > 5;

  return (docsList.length > 0 ?
    <Alert title={t('PROVIDE_FOLLOWING_REF_DOCS')} >
      <div className={`grid gap-4, p-2  ${isMultiRow ? 'grid-cols-3' : 'grid-cols-1'}`}>
        {docsList.map((docName) => <div>{t(sluggify(docName))}</div>)}
      </div>
    </Alert> : null
  )
}

export default ShowRequiredDocsBanner